import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { GoogleTagManagerService } from "angular-google-tag-manager";
import { GoogleAnalyticsService } from "ngx-google-analytics";
import { ToastrService } from "ngx-toastr";
import { MetaPixelService } from "src/app/services/metapixel.service";
import { SignupService } from "src/app/services/signup.service";
import { AppState } from "src/app/store/app.reducer";

@Component({
    selector: 'ship-to-united-states',
    templateUrl: './ship-to-united-states.component.html',
    styleUrls: ['./ship-to-united-states.component.css']
})

export class ShipToUnitedStatesComponent implements OnInit {

    countryFrom = '';


    shippingCalcForm = new FormGroup({
        fromCountry: new FormControl('', Validators.required),
        toCountry: new FormControl('US', Validators.required),
        weightUnit: new FormControl('lbs', Validators.required),
        parcelWeight: new FormControl(1, [Validators.required, Validators.min(1)]),
        dimensionUnit: new FormControl('inch'),
        width: new FormControl(0),
        height: new FormControl(0),
        length: new FormControl(0)
    })
    constructor(
        private signUpService: SignupService,
        private toastr: ToastrService,
        private metaPixelService: MetaPixelService,
        private $gaService: GoogleAnalyticsService,
        private router: Router,
        private store: Store<AppState>,
        private gtmService: GoogleTagManagerService
    ) {

    }
    hostCountries;
    allCountries;
    token;
    userID;

    ngOnInit(): void {
        this.store.select('auth').subscribe(state => {
            this.token = state.token;
            this.userID = state.user?.id;
        })
        this.signUpService.getHostCountries().subscribe(list => {
            this.hostCountries = list["data"];
            // this.countryFrom = list["data"][0]["code"];
        })
        this.signUpService.getAllCountries().subscribe(list => {
            this.allCountries = list["data"];
        })

    }

    checkInputValidations() {
        var hasError = false;
        if (this.shippingCalcForm.controls.fromCountry.status == "INVALID") {
            this.toastr.error("Please select a from country!")
            this.shippingCalcForm.controls.parcelWeight.markAsTouched()
            hasError = true;
        }
        if (this.shippingCalcForm.controls.parcelWeight.status == "INVALID") {
            this.shippingCalcForm.controls.parcelWeight.markAsTouched()
            hasError = true;
        }
        return hasError;
    }
    priceError;
    priceText;
    isLoading;
    priceErrorText;
    countryTo;
    hasCourierOptions;
    courierData;
    calculatePrice() {
        if (this.shippingCalcForm.value.parcelWeight <= 0) {
            return this.toastr.error("Parcel weight must be greater than 0!")
        }
        if (this.checkInputValidations() == false) {
            this.isLoading = true;
            this.priceText = 0.00;
            var amountArray = [];
            this.signUpService.calculatePricing("", this.shippingCalcForm.value.toCountry, this.shippingCalcForm.value.fromCountry, this.shippingCalcForm.value.parcelWeight ?? 0, this.shippingCalcForm.value.weightUnit, this.shippingCalcForm.value.width ?? 0, this.shippingCalcForm.value.height ?? 0, this.shippingCalcForm.value.length ?? 0, this.shippingCalcForm.value.dimensionUnit, "").subscribe(data => {
                if (data["result"]["status"] != 200) {
                    this.priceError = true;
                    this.priceErrorText = data["result"]["message"];
                    this.toastr.error(data["result"]["message"], 'Error');
                    this.isLoading = false;
                    this.hasCourierOptions = false;
                }
                else {
                    if (data["data"]["shipment_amount"]?.length > 0) {
                        this.hasCourierOptions = true;

                        const filteredData = data["data"]["shipment_amount"].map(item => {
                            return {
                              ...item,
                              shipment_amount_after_discount: item.shipment_amount_after_discount.toFixed(2),
                              total_shipment_amount: item.total_shipment_amount.toFixed(2)
                            }
                          })
                          this.courierData = filteredData;
                    }
                    for (let index = 0; index < data["data"]["shipment_amount"]?.length; index++) {
                        amountArray.push(data["data"]["shipment_amount"][index]["shipment_amount_after_discount"]);
                    }
                    
                    if (this.userID && this.token) {
                        this.signUpService.getUserByUserID(this.userID, this.token).subscribe(user => {
                            let metaPixelEventObject = {
                                country_from: this.countryFrom,
                                country_to: this.countryTo,
                                user_email: user['data'].email
                            }
                            //this.metaPixelService.onPricingCalculation(metaPixelEventObject);
                        })
                    } else {
                        let metaPixelEventObject = {
                            country_from: this.countryFrom,
                            country_to: this.countryTo,
                        }
                        //this.metaPixelService.onPricingCalculation(metaPixelEventObject);
                    }
                    this.$gaService.event("calculate_price", "calculate_price", this.countryFrom + "-" + this.countryTo)
                    const gtmTag = {
                        event: 'gtmCalculatePrice',
                        data: {
                          countryFrom: this.countryFrom,
                          countryTo: this.countryTo,
                        }
                      }
                      this.gtmService.pushTag(gtmTag);
                    if (amountArray.length > 0) {
                        this.priceText = Math.min.apply(Math, amountArray);
                    }
                    else {
                        this.priceText = 0
                    }
                    this.isLoading = false;
                    this.priceError = false;
                    document.getElementById('booster--calculation--result').scrollIntoView({ behavior: 'smooth', block: 'start' })
                }
            })
        }
    }


    goToShopFrom() {
        let countryCode = this.shippingCalcForm.controls['fromCountry'].value ?? '';
        if (countryCode) {
            this.router.navigateByUrl(`/en/shop-from/${countryCode.toLowerCase()}`)
        } else {
            this.router.navigateByUrl('/en/shop-from')
        }
    }
}